const initiatedByOptions = [
  {
    value: 'ACCOUNT_HOLDER',
    label: 'Account holder',
  },
  {
    value: 'AUTHORIZED_SIGNATURE',
    label: 'Authorized signature',
  },
  {
    value: 'BJB_MANAGEMENT_BOARD_DIRECTORS',
    label: 'BJB management board directors',
  },
  {
    value: 'FINDER',
    label: 'Finder',
  },
  {
    value: 'HOLDER_OF_INFORMATION_AUTHORIZATION',
    label: 'Holder of information authorization',
  },
  {
    value: 'INTERMEDIARY',
    label: 'Intermediary',
  },
  {
    value: 'INVESTMENT_ADVISORY',
    label: 'Investment advisory',
  },
  {
    value: 'LEGAL_SUCCESSOR',
    label: 'Legal successor',
  },
  {
    value: 'OTHER_FRONT_EMPLOYEE',
    label: 'Other front employee',
  },
  {
    value: 'POWER_OF_ATTORNEY_HOLDER',
    label: 'Power of attorney holder',
  },
  {
    value: 'PROSPECT',
    label: 'Prospect',
  },
  {
    value: 'RELATIONSHIP_MANAGER',
    label: 'Relationship manager',
  },
  {
    value: 'WP_RESPONSIBLE',
    label: 'WP responsible',
  },
  {
    value: 'OTHER',
    label: 'Other',
  },
];
export default initiatedByOptions;
